import moment from "moment";

const API_DATE_FROMAT = "YYYY-MM-DD";

export default {
  hasNonEmptyProperties: function(obj, props) {
    for (var i in props) {
      if (!(obj.hasOwnProperty(props[i]) && obj[props[i]])) {
        return false;
      }
    }

    return true;
  },
  hasMoreThanOneKey: function(obj) {
    return Object.keys(obj).length > 1;
  },
  extractProperties: function(obj, props) {
    var result = {};

    for (var i = 0; i < props.length; i++) {
      if (obj.hasOwnProperty(props[i])) {
        result[props[i]] = obj[props[i]];
      }
    }

    return result;
  },
  removeEmptyProperties: function(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        if (!obj[prop]) {
          delete obj[prop];
        }
      }
    }

    return obj;
  },

  removeEmptyPropertiesIncludingNested: function(obj) {
    Object.keys(obj).forEach(key => {
      if (!(obj[key] instanceof Date)) {
        if (obj[key] && typeof obj[key] === "object") {
          this.removeEmptyPropertiesIncludingNested(obj[key]);
        }
        if (typeof obj[key] === "object" && this.isEmpty(obj[key])) {
          obj[key] = null;
        }
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      }
    });
    return obj;
  },

  isEmpty: function(map) {
    for (var key in map) {
      if (map.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  },

  removeNullValues: function(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        if (obj[prop] === "0") {
          delete obj[prop];
        }
      }
    }
    return obj;
  },

  encodeDates: function encodeDates(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        if (obj[prop] instanceof Date) {
          obj[prop] = moment(obj[prop]).format(API_DATE_FROMAT);
        } else if (obj[prop] != null && typeof obj[prop] === "object") {
          encodeDates(obj[prop]);
        }
      }
    }
  },

  parseDates: function parseDates(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        if (typeof obj[prop] === "string") {
          var mDate = moment(obj[prop], API_DATE_FROMAT, true);

          if (mDate.isValid()) {
            obj[prop] = mDate.toDate();
          }
        } else if (obj[prop] != null && typeof obj[prop] === "object") {
          parseDates(obj[prop]);
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/login/utils/object-helper.js